import * as styles from "./ScrollAreaThumb.css";

import { clsx } from "clsx";
import type { JSX } from "react";

import { ScrollArea as BaseScrollArea } from "@base-ui/react/scroll-area";

import type { ScrollAreaThumbProps } from "./ScrollArea.types";

export function ScrollAreaThumb({
  className,
  ...props
}: ScrollAreaThumbProps): JSX.Element {
  return (
    <BaseScrollArea.Thumb
      data-slot="scroll-area-thumb"
      className={clsx(styles.thumb, className)}
      {...props}
    />
  );
}
